export enum NetworkIntegrityProviderTypes {
  Network = "Network",
  Servicing = "Servicing",
  Prospect = "Prospect",
  ProspectServicing = "ProspectServicing",
}

export enum NetworkIntegrityMembership {
  Primary = "Primary",
  Secondary = "Secondary",
}

export enum NetworkIntegrityActionStatus {
  All = "All",
  NoActionsApplied = "NoActionsApplied",
  Terminated = "Terminated",
}

export const NetworkIntegrityActionStatusDisplay: Record<NetworkIntegrityActionStatus, string> = {
  [NetworkIntegrityActionStatus.All]: "All",
  [NetworkIntegrityActionStatus.NoActionsApplied]: "No Actions Applied",
  [NetworkIntegrityActionStatus.Terminated]: "Terminated",
};

export enum NetworkIntegrityDisplayMode {
  Current = "Current",
  TotalAfterTermed = "TotalAfterTermed",
}
